import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../common/ui/dialog';
import { Button } from '../../common/ui/button';
import { Sparkles, Settings2 } from 'lucide-react';

export default function AgentCreateChooser({ isOpen, onClose, onQuickSetup, onAdvanced }) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Create agent</DialogTitle>
          <DialogDescription>Choose how you want to get started</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          <button
            type="button"
            onClick={() => {
              onClose();
              onQuickSetup();
            }}
            className="flex items-start gap-3 p-4 rounded-lg border-2 border-indigo-200 dark:border-indigo-800 bg-indigo-50/50 dark:bg-indigo-900/20 text-left hover:border-indigo-400 transition-colors"
          >
            <Sparkles className="h-6 w-6 text-indigo-600 shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold">Quick setup</p>
              <p className="text-sm text-muted-foreground mt-1">
                Templates and a short wizard. Recommended for most users.
              </p>
            </div>
          </button>
          <button
            type="button"
            onClick={() => {
              onClose();
              onAdvanced();
            }}
            className="flex items-start gap-3 p-4 rounded-lg border text-left hover:bg-muted/50 transition-colors"
          >
            <Settings2 className="h-6 w-6 text-muted-foreground shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold">Advanced editor</p>
              <p className="text-sm text-muted-foreground mt-1">
                Full control over STT, LLM, TTS, presets, and recording.
              </p>
            </div>
          </button>
        </div>
        <Button type="button" variant="ghost" className="w-full" onClick={onClose}>
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
}
